/* eslint-disable no-extend-native */
export {}; // This is needed to make this file a module.

declare global {
    interface Array<T> {
        countWhere(callbackFn?: (value: T) => boolean): number;
    }
}

Array.prototype.countWhere = function (
    callbackFn: (value: any) => boolean
): number {
    return this.reduce(
        (count, value) => count + (callbackFn ? +callbackFn(value) : 1),
        0
    );
};
